var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.onScroll,
      expression: "onScroll"
    }],
    staticClass: "scroll-top rounded-lg",
    attrs: {
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "color": "white",
      "transition": "slide-x-transition"
    },
    on: {
      "click": function click($event) {
        return _vm.$vuetify.goTo(_vm.target, _vm.options);
      }
    }
  }, [_c('span', {
    staticClass: "page-text page-text--xs font-weight-medium grey--text text--darken-4"
  }, [_vm._v(" TOP ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }